<template>
	<div class="assign-to-user">
		<el-select size="small" v-model="toUserId" v-loading="loading" style="width: 240px" filterable placeholder="选择指派人">
			<el-option v-for="item in userList" :key="item.id" :label="item.nickname + '（' + item.login_name + '）'" :value="item.id"></el-option>
		</el-select>
		<el-button class="v-ml-10" type="primary" size="small" :loading="doSubmitLoading" @click="doSubmit(1)">确认指派</el-button>
	</div>
</template>

<script>
	export default {
		props:{
			id:Number,
			worksId:Number,
		},
		data(){
			return{
				toUserId:'',
				loading:false,
				userList:[],
				doSubmitLoading:false,
			}
		},
		created(){
			this.getUserList()
		},
		methods:{
			async getUserList() {
				this.loading = true;
				try {
					let res = await this.api.user.dealUserList({works_id: this.worksId});
					this.userList = res.data;
				} catch (e) {
					console.error(e);
				}
				this.loading = false;
			},
			async doSubmit(){
				try{
					await this.api.polyline.roam({id: this.id, status: 1, to_user_id: this.toUserId});
					this.$message.success('指派成功');
					this.$emit('success');
					this.$emit('update',1);
				}catch (e) {
					console.error(e)
				}
			}
		}
	}
</script>